"use client";

import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
import type { OddsDisplaySettings } from "@/lib/tenant/TenantSettingsProvider";

/**
 * Returns the tenant-resolved odds display settings.
 * Callsites use this to default `styles.mode` and `styles.flashInterval`
 * on `BettingOdds`/`BettingOddsUI`. Explicit callsite props still win.
 */
export function useOddsDisplay(): OddsDisplaySettings {
    return useTenantSettings().odds;
}
